// src/store/slices/ownerAuthSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {
  owner: null,
  token: localStorage.getItem('ownerToken') || null,
  isAuthenticated: !!localStorage.getItem('ownerToken'),
  isLoading: false,
  error: null
};

export const fetchOwnerProfile = createAsyncThunk(
  'ownerAuth/fetchProfile',
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('ownerToken');
      if (!token) {
        throw new Error('No token found');
      }

      const response = await axios.get(
        'https://fastapi-backend-657266059621.asia-northeast1.run.app/api/owner/profile',
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.detail || 'Failed to fetch profile'
      );
    }
  }
);

const ownerAuthSlice = createSlice({
  name: 'ownerAuth',
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.token = action.payload;
      state.isAuthenticated = true;
      state.error = null;
      localStorage.setItem('ownerToken', action.payload);
    },
    loginFailure: (state, action) => {
      state.token = null;
      state.isAuthenticated = false;
      state.error = action.payload;
      localStorage.removeItem('ownerToken');
    },
    logout: (state) => {
      state.owner = null;
      state.token = null;
      state.isAuthenticated = false;
      state.error = null;
      localStorage.removeItem('ownerToken');
    },
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOwnerProfile.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchOwnerProfile.fulfilled, (state, action) => {
        state.isLoading = false;
        state.owner = action.payload;
      })
      .addCase(fetchOwnerProfile.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        if (action.payload === 'Unauthorized' || action.payload === 'No token found') {
          state.owner = null;
          state.token = null;
          state.isAuthenticated = false;
          localStorage.removeItem('ownerToken');
        }
      });
  }
});

export const { loginSuccess, loginFailure, logout, clearError } = ownerAuthSlice.actions;
export default ownerAuthSlice.reducer;
